import React, { useMemo } from 'react'
import { Typography, Stack } from '@mui/material';
import {
    SEM_IMAGEM,
    collectProductImageUrls,
    createImageFallbackHandler,
    getProductThumbUrl,
} from '../utils/productImageUrl';

const CartItemPedidos = ({ cartItem }) => {
    const candidates = useMemo(() => {
        const urls = collectProductImageUrls(cartItem);
        return urls.length ? urls : [SEM_IMAGEM];
    }, [cartItem]);
    const imgSrc = getProductThumbUrl(cartItem, SEM_IMAGEM);
    const handleError = createImageFallbackHandler(candidates, SEM_IMAGEM);

    return (
        <div className="row mt-3 no-gutters">
            <div className="col-md-3">
                <img
                    width={80}
                    height={80}
                    src={imgSrc}
                    className="card-img-top"
                    alt={cartItem?.use_descricao || cartItem?.name || ''}
                    data-fallback-index="0"
                    onError={handleError}
                    style={imgSrc === SEM_IMAGEM ? { padding: 10 } : undefined}
                />
            </div>
            <div className="col-md-9">
                <div style={{ fontSize: 12, paddingBottom: 5, fontWeight: 'bold' }} className="mt-2">{cartItem.use_des}</div>
            </div>
            <div className="col-md-12">
                <Stack direction={"column"}>
                    <Stack>
                        <Typography>{cartItem?.name}</Typography>
                    </Stack>
                    <Stack spacing={1}>
                        <Typography style={{ fontSize: 12, fontWeight: 'bold' }} className="mt-2"></Typography>
                        <Typography>Referência: <strong>{cartItem?.use_referencia}</strong></Typography>
                        <Stack spacing={1} direction={"row"}>
                            <Typography>Cod Cor: <strong>{cartItem?.use_cod_cor_produto}</strong></Typography>
                            <Typography>Cor: <strong>{cartItem?.use_cor_produto}</strong></Typography>
                        </Stack>
                        <Stack spacing={1} direction={"row"}>
                            <Typography>loja: <strong>{cartItem?.filial}</strong></Typography>
                            <Typography>tamanho: <strong>{cartItem?.grade}</strong></Typography>
                        </Stack>
                    </Stack>
                </Stack>
            </div>
        </div>

    )
}

export default CartItemPedidos;
